import ScatterPlotChart from './ScatterPlotChart';

export default ScatterPlotChart;
